import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { injectable } from "tsyringe";
import { DataFormat } from "utils/format/DataFormat";
import { StringFormat } from "utils/format/StringFormat";
import { IFilterRepository } from "../domain/repository/IFilterRepository";

@injectable()
export class FilterRepositoryImpl implements IFilterRepository {
  async getFilterList<P extends Object, R extends Object>(
    path: string,
    params: P,
  ): Promise<ListBaseApiResponseModel<R>> {
    const url = StringFormat.buildListUrl<P>(path, params);
    const preparedParams = DataFormat.prepareParamsForApi(params);
    return await client?.get(url, preparedParams);
  }

  async getFilterDetail<P extends Object, R extends Object>(
    path: string,
    params: P,
  ): Promise<BaseApiResponseModel<R>> {
    return await client?.get(path, params);
  }
}
